
  import { mixins, Options } from "vue-class-component";
  import { ScrollTop } from "@/mixins/utilities";
  import ContactForm from "@/components/forms/ContactForm.vue";
  import Spinner from "@/components/misc/Spinner.vue";

  @Options({
    components: {
      ContactForm,
      Spinner
    },
    emits: ['loading']
  })

  export default class ProductRangeView extends mixins(ScrollTop) { }
